 
import { AccountInfoModel } from "../generated/api";
import {accessTokenLocalStorage, SessionActiveLocalStorage, SignedOutSessionStorage, UserProfileLocalStorage} from "./Constants";
import  secureLocalStorage  from  "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { JwtPayload } from "../models/JwtPayload";
 

export class storageMng {
    
  static setItem(key:string,value:string ){ 
      secureLocalStorage.setItem(key, value);
  } 
  static getItem(key:string):string | undefined{ 
    const value =secureLocalStorage.getItem(key);
    return value?value.toString():undefined;
  }
  public static remove(key:string){ 
    secureLocalStorage.removeItem(key);
  }
  
  public static storUserProfile(userData:AccountInfoModel|undefined){
    let data=JSON.stringify(userData ?? {});
    this.setItem(UserProfileLocalStorage, data);
  }
  
  public static storAccessToken(accessToken:string|undefined){ 
    this.setItem(accessTokenLocalStorage, accessToken??"");
  }

  public static getUserProfile():AccountInfoModel|undefined{
    ////////////////////////////////////////////////////

      // TODO : get info from decoding the Access token 

      // const token = this.getItem(accessTokenLocalStorage);
      // if (!token) return undefined;
    
      // try {
      //   const decoded = jwtDecode<JwtPayload>(token); 
      //   return decoded;
      // } catch (e) {
      //   console.error("Invalid token", e);
      //   return undefined;
      // }
      
    ///////////////////////////////////////////////////
    
    const json = this.getItem(UserProfileLocalStorage);
    if(json)
    {
      const usr=JSON.parse(json) as AccountInfoModel;
      return usr;
    }
    else
      return undefined;
  } 

  public static getِAccessToken():string|undefined{
      return this.getItem(accessTokenLocalStorage);
  } 

  public static removeUserProfile(){
    this.remove(UserProfileLocalStorage);
  }

  public static storSignedOut(isSignedOut:string ){
    this.setItem(SignedOutSessionStorage, isSignedOut);
  }
  public static getSignedOut():string|undefined{
    return this.getItem(SignedOutSessionStorage);
  }
  public static removeSignedOut(){
    this.remove(SignedOutSessionStorage);
  }

  // ── Plain (unencrypted) session marker ──────────────────────────────────
  // Deliberately bypasses react-secure-storage: its AES key is derived from a
  // browser fingerprint (incl. a canvas print) that can come out differently
  // between page loads, which makes secureLocalStorage.getItem() intermittently
  // fail to decrypt an otherwise-valid token. A plain flag lets route guards
  // tell "genuinely signed out" apart from "this page load failed to decrypt
  // a session that really exists" so they can recover with a reload instead of
  // wrongly bouncing a logged-in user to the not-authorized page.
  public static storSessionActive(){
    try { window.localStorage.setItem(SessionActiveLocalStorage, "1"); } catch { /* storage unavailable */ }
  }
  public static isSessionActive(): boolean {
    try { return window.localStorage.getItem(SessionActiveLocalStorage) === "1"; }
    catch { return false; }
  }
  public static removeSessionActive(){
    try { window.localStorage.removeItem(SessionActiveLocalStorage); } catch { /* storage unavailable */ }
  }

  public static clearStorage(){
    this.removeUserProfile();
    this.removeSignedOut();
    this.removeSessionActive();
  }
  
};

